import React, {PropsWithChildren, useMemo} from 'react';
import {IElement} from '../../../../incase-domain/elements';
import {WrapperTooltip} from './WrapperTooltip';

interface BaseElementWrapperProps {
    isActive?: boolean;
    onOptions?: (id: string, silent?: boolean) => void;
    isError?: boolean;
    element: IElement;
}

BaseElementWrapper.defaultProps = {
    isActive: false,
};

function BaseElementWrapper(props: PropsWithChildren<BaseElementWrapperProps>): JSX.Element {
    const {isActive, isError, onOptions, children, element} = props;

    const fitContent = useMemo(() => {
        const height = Number(element.height.split('%')[0]);
        const heightIsMax = Number.isFinite(height) && height >= 100;
        return element.fitContent && !heightIsMax;
    }, [element]);

    const elementHeight = useMemo(() => {
        const height = element.height.split('%');
        if (height.length >= 1) {
            return +height[0];
        }

        return 0;
    }, [element.height]);

    return (
        <div
            className={`c-baseElementWrapper ${isActive ? 'is-active' : ''} ${isError ? 'c-baseElementWrapper--error' : ''} ${
                fitContent && elementHeight < 100 ? 'c-baseElementWrapper--fitContent' : ''
            }`}
        >
            <div className="c-baseElementWrapper__content" onMouseDown={() => onOptions?.(element.id)}>
                <div id="slide-element" style={{width: '100%', height: '100%', overflow: 'hidden'}}>
                    {children}
                </div>

                <div className="c-baseElementWrapper__borderItems">
                    <div className="c-baseElementWrapper__borderSquare c-baseElementWrapper__borderSquare--top" />
                    <div className="c-baseElementWrapper__borderSquare c-baseElementWrapper__borderSquare--bottom" />
                    <div className="c-baseElementWrapper__borderSquare c-baseElementWrapper__borderSquare--left" />
                    <div className="c-baseElementWrapper__borderSquare c-baseElementWrapper__borderSquare--right" />
                    <div className="c-baseElementWrapper__borderCircle c-baseElementWrapper__borderCircle--topLeft" />
                    <div className="c-baseElementWrapper__borderCircle c-baseElementWrapper__borderCircle--topRight" />
                    <div className="c-baseElementWrapper__borderCircle c-baseElementWrapper__borderCircle--bottomLeft" />
                    <div className="c-baseElementWrapper__borderCircle c-baseElementWrapper__borderCircle--bottomRight" />
                </div>
                <WrapperTooltip element={element} onOptions={onOptions} />
            </div>
        </div>
    );
}

export default BaseElementWrapper;
